import { ImSpinner10 } from "react-icons/im";

const Spinner = ({ image = false, message = "", description = "" }) => {
  return (
    <div className={!image ? "spinnerContainer" : ""}>
      <div className={!image ? "spinner" : "spinnerImage"}>
        <ImSpinner10 className="spinning" size={image ? "85%" : "130px"} />
      </div>
      {message && <div className="spinnerMessage">{message}</div>}
      {description && (
        <div className="spinnerDescription">
          {description}
        </div>
      )}
    </div>
  );
};

export default Spinner;
